import { render, staticRenderFns } from "./queue-report.vue?vue&type=template&id=07f9fa56&"
import script from "./queue-report.vue?vue&type=script&lang=js&"
export * from "./queue-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports